import { createSlice } from '@reduxjs/toolkit';

import { getDefaultDate } from '../../utils/date';
import { updateContentFilterSettings } from './actions';
import { CONTENT_FILTER_SETTINGS_SLICE_NAME } from './constants';
import type { AzureContentFilter, ContentFilterSettingsType } from './types';

export const DEFAULT_AZURE_CONFIG: AzureContentFilter = {
  selfHarm: { isActive: false, precision: 'MEDIUM' },
  violence: { isActive: false, precision: 'MEDIUM' },
  sexual: { isActive: false, precision: 'MEDIUM' },
  hate: { isActive: false, precision: 'MEDIUM' },
};

const initialState: ContentFilterSettingsType = {
  type: 'azure',
  azureConfig: DEFAULT_AZURE_CONFIG,
  disabled: false,
  // ISO string
  updatedAt: '',
  updatedBy: '',
};

const slice = createSlice({
  name: CONTENT_FILTER_SETTINGS_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(updateContentFilterSettings, (state, action) => {
      state.type = action.payload.type;
      state.azureConfig = action.payload.azureConfig as AzureContentFilter;
      if (action.payload.disabled !== undefined) {
        state.disabled = action.payload.disabled;
      }
      state.updatedAt = getDefaultDate();
    });
  },
});

export default slice.reducer;
